import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/";

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState("");

    const onSubmit = async (e) => {
        e.preventDefault();
        setErr("");
        setBusy(true);
        try {
            await login(email.trim(), password);
            // keep your existing behavior so userId fallbacks still work
            localStorage.setItem("trader_id", email.trim());
            navigate(from, { replace: true });
        } catch (e2) {
            const msg =
                e2?.message && e2.message !== "Error"
                    ? e2.message
                    : "Invalid email or password.";
            setErr(msg);
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="w-full min-h-screen flex items-center justify-center bg-slate-950 text-slate-100 p-6">
            <form
                onSubmit={onSubmit}
                className="w-full max-w-sm bg-slate-900 border border-slate-700 rounded-2xl p-6 space-y-4 shadow-xl"
            >
                <h1 className="text-2xl font-bold text-blue-400">Sign in</h1>

                <label className="block text-sm space-y-1">
                    <span className="text-slate-300">Email</span>
                    <input
                        type="email"
                        className="mt-1 w-full bg-slate-950 border border-slate-700 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        autoComplete="email"
                        required
                    />
                </label>

                <label className="block text-sm space-y-1">
                    <span className="text-slate-300">Password</span>
                    <input
                        type="password"
                        className="mt-1 w-full bg-slate-950 border border-slate-700 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        autoComplete="current-password"
                        required
                    />
                </label>

                {err && (
                    <div className="text-red-400 text-xs bg-red-950/40 border border-red-700 rounded px-3 py-2">
                        {err}
                    </div>
                )}

                <button
                    type="submit"
                    disabled={busy}
                    className={`w-full py-2 rounded-xl font-semibold text-sm ${busy
                            ? "bg-slate-700 cursor-wait"
                            : "bg-blue-600 hover:bg-blue-500 cursor-pointer"
                        }`}
                >
                    {busy ? "Signing in�" : "Sign in"}
                </button>

                <div className="text-sm text-slate-400">
                    No account?{" "}
                    <Link
                        to="/register"
                        className="text-blue-400 hover:underline font-medium"
                    >
                        Create one
                    </Link>
                </div>

                <Link
                    to="/forgot"
                    className="text-blue-400 hover:underline text-xs font-medium"
                >
                    Forgot your password?
                </Link>
            </form>
        </div>
    );
}
